"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQueryString = exports.fetchCountry = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _domains = require("./domains");

var _utils = require("./utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var QUERY_STRING_BASE = "?";
var utmMediumAllowed = ["direct", "organic", "social", "social-network", "social-media", "sm", "social network", "social media", "email", "affiliate", "referral", "cpc", "ppc", "paidsearch", "cpv", "cpa", "cpp", "content-text", "display", "cpm", "banner", "referral-influencer", "referral-afiliado", "mail", "eventos", "bau-display", "bau-paid"];
/* istanbul ignore next */

var getUrlApi = function getUrlApi() {
  if (process.env.GATSBY_API_URL_IP_INFO) return process.env.GATSBY_API_URL_IP_INFO;
  if (process.env.REACT_APP_API_IP_INFO) return process.env.REACT_APP_API_IP_INFO;
  if (process.env.NODE_API_IP_INFO) return process.env.NODE_API_IP_INFO;

  if (process.env.NODE_ENV === "production") {
    throw new Error("IP_INFO is not defined");
  } else {
    console.warn("IP_INFO is not defined");
  }

  return "";
};
/* istanbul ignore next */


var fetchCountry = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var full,
        country,
        urlApiIpInfo,
        response,
        json,
        _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            full = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
            country = "Uruguay";
            urlApiIpInfo = getUrlApi();

            if (urlApiIpInfo) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", country);

          case 5:
            _context.prev = 5;
            _context.next = 8;
            return fetch(urlApiIpInfo, {
              credentials: "omit",
              headers: {
                Authorization: "JhbGciOiJIUzI"
              }
            });

          case 8:
            response = _context.sent;
            _context.next = 11;
            return response.json();

          case 11:
            json = _context.sent;

            if (full) {
              country = json;
            } else {
              country = json.countryName;
            }

            _context.next = 18;
            break;

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](5);
            console.log(_context.t0);

          case 18:
            return _context.abrupt("return", country);

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 15]]);
  }));

  return function fetchCountry() {
    return _ref.apply(this, arguments);
  };
}();

exports.fetchCountry = fetchCountry;

var urlHasUtmMediumInQueryString = function urlHasUtmMediumInQueryString(location) {
  if (!location) return false;
  var search = location.search;

  if (search.length > 0 && search.includes("utm_medium")) {
    var paramsSearch = (0, _utils.getParamsFromQueryString)(search);

    if (paramsSearch["utm_medium"] && utmMediumAllowed.includes(paramsSearch["utm_medium"])) {
      return true;
    }
  }

  return false;
};

var urlHasMcOrigenInQueryString = function urlHasMcOrigenInQueryString(location) {
  if (!location) return false;
  var search = location.search;
  return search.length > 0 && search.includes("mc_origen");
};

var didTheUserEnterDirectly = function didTheUserEnterDirectly(document) {
  if (!document) return false; // console.warn(`testing ${document.referrer.length}`)

  return document.referrer.length === 0;
};

var directQueryString = function directQueryString(location, country, hasMcOrigen, hasUtm) {
  var params = _objectSpread({}, (0, _utils.getParamsFromQueryString)(location.search));

  if (hasMcOrigen) {
    params.utm_medium = "direct";
  }

  if (hasUtm) {
    params.mc_origen = "Directo";
  }

  if (!hasMcOrigen && !hasUtm) {
    params.utm_medium = "direct";
    params.mc_origen = "Directo";
  }

  if (typeof country !== "undefined") {
    params["country"] = country;
  }

  return "".concat(QUERY_STRING_BASE) + reduceParamsToQueryParams(params);
};

var reuseQueryString = function reuseQueryString(location, country) {
  if (!location) return "";
  if (typeof country === "undefined") return location.search;

  if (location.search.includes("country")) {
    return location.search;
  } else {
    return location.search + "&country=" + country;
  }
};

var organicQueryString = function organicQueryString(document, country, hasMcOrigen, hasUtm) {
  if (!document) return "";
  var domain = "referral";

  var params = _objectSpread({}, (0, _utils.getParamsFromQueryString)(document.location.search));

  var utmMedium = "referral";
  var utmSource = "referral";
  var mcOrigen = "Referral";

  try {
    var referrer = new URL(document.referrer);
    domain = referrer.hostname;
    utmSource = domain;
  } catch (error) {
    console.warn("Bad referrer");
  }

  if (_domains.DOMAINS[domain]) {
    utmMedium = _domains.DOMAINS[domain];
    utmSource = domain;
  }

  if (_domains.DOMAINS_MC_ORIGEN[domain]) {
    mcOrigen = _domains.DOMAINS_MC_ORIGEN[domain];
  }

  if (hasMcOrigen) {
    params.utm_medium = utmMedium;
    params.utm_source = utmSource;
  }

  if (hasUtm) {
    params.mc_origen = mcOrigen;
  }

  if (!hasMcOrigen && !hasUtm) {
    params.utm_medium = utmMedium;
    params.utm_source = utmSource;
    params.mc_origen = mcOrigen;
  }

  if (typeof country !== "undefined" && params.country === undefined) {
    params["country"] = country;
  }

  return "".concat(QUERY_STRING_BASE).concat(reduceParamsToQueryParams(params));
};

var reduceParamsToQueryParams = function reduceParamsToQueryParams(params) {
  return Object.entries(params).map(function (value) {
    return "".concat(value[0], "=").concat(value[1]);
  }).join("&");
};

var getQueryString = function getQueryString(location, document, country) {
  var queryString;
  var hasMcOrigen = urlHasMcOrigenInQueryString(location);
  var hasUtm = urlHasUtmMediumInQueryString(location);

  if (hasUtm && hasMcOrigen) {
    queryString = reuseQueryString(location, country);
  } else if (didTheUserEnterDirectly(document)) {
    queryString = directQueryString(location, country, hasMcOrigen, hasUtm);
  } else {
    queryString = organicQueryString(document, country, hasMcOrigen, hasUtm);
  }

  return queryString;
};

exports.getQueryString = getQueryString;